/**
 * Kiosk Vuex Store Module State
 * @property {string} cordovaStatus - current cordova state
 */
export const state = {
  charge:         null,
  pastOrdersShow: false,
};

/**
 * Kiosk Vuex Store Module Getters
 * @property {boolean} isCordovaReady - provide info if cordova loaded
 */
export const getters = {
  getChargeId:    state => state.charge || 'No charge received yet',
  pastOrdersShow: state => state.pastOrdersShow,
};

export default {
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/apps/kiosk/store/state.js